export default {
  products: [], //all products
  product: null, //single product
  categories: [], //all categories
  carts: [],//all user  cart
};
